import Image from 'next/image';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useEventGeneratorClickCta } from 'src/analytics/useEventGeneratorClickCta';
import { Button } from 'src/components';
import { useCtaHref } from 'src/hooks/useCtaHref';
import { useLanguagePairContext } from 'src/context/languagePair';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import imageSrcEn from './images/blue-beetle-bug-en.jpg';
import imageSrcEs from './images/blue-beetle-bug-es.jpg';
import * as S from './styles';
import * as msgsData from './messages';

const { msgs, ...localesWithMessages } = msgsData;

const Jumbotron: FC = () => {
  const intl = useIntl();
  const { sourceLanguageLocale } = useLanguagePairContext();

  const imageSrc = ['es', 'es-mx'].includes(sourceLanguageLocale) ? imageSrcEs : imageSrcEn;

  const targetMsgs = useTargetMessages(localesWithMessages);

  const cta = intl.formatMessage(targetMsgs.cta);
  const text = intl.formatMessage(msgs.text);
  const title = intl.formatMessage(targetMsgs.title);
  const topic = intl.formatMessage(msgs.topic);

  const signUpHref = useCtaHref();
  const eventGeneratorClickCta = useEventGeneratorClickCta();

  return (
    <S.Section>
      <S.ImageWrapper>
        <Image alt="" src={imageSrc} fill sizes="100vw" />
      </S.ImageWrapper>

      <S.SectionContent>
        <S.Card>
          <S.Topic>{topic}</S.Topic>
          <S.Title>{title}</S.Title>
          <S.Text>{text}</S.Text>
          <Button
            analyticsEvent={eventGeneratorClickCta}
            buttonSizeBreakpoint="md"
            buttonType="primary"
            disableMinWidth
            fullWidth="md"
            href={signUpHref}
          >
            {cta}
          </Button>
        </S.Card>
      </S.SectionContent>
    </S.Section>
  );
};

export default Jumbotron;
